import {Component, OnInit,Output, EventEmitter} from 'ng-metadata/core';
import {OPAC_TAB,ChangeTabEvent} from '../search/fullView/getit/opac/opac.directive';
import {LimitedHistoryStack} from '../infra/dataStructures/collections/stack/limitedHistoryStack.structure';
import { OpacService } from '../search/fullView/getit/opac/opac.service';
import { RequestService } from '../search/fullView/getit/opac/request/request.service';

@Component({
    selector: 'prm-blank-purchase-request',
    templateUrl: 'components/purchaseRequest/purchase_request.html'
})

export class PrmPurchaseRequest implements OnInit{

    @Output()   private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();

    public backToHistoryStack: LimitedHistoryStack<OPAC_TAB>;
    private defaultTab = OPAC_TAB.REQUEST;
    private _selectedTab:OPAC_TAB;
    private BACK_HISTORY_SIZE :number = 12;
    private service;

    constructor(private requestService : RequestService,
                private opacService : OpacService) {
        this.backToHistoryStack = new LimitedHistoryStack<OPAC_TAB>(this.BACK_HISTORY_SIZE);
        this._selectedTab = this.defaultTab;
    }

    public getRequestIsLoading(){
        return this.requestService.requestIsLoading;
    }
    public onChangeTabEvent($event){
        let eventData:ChangeTabEvent = $event;

        if($event === null){
            this.selectedTab = this.backToHistoryStack.pop() || this.defaultTab;
        } else {
            if(eventData.referer !== undefined) {
                this.backToHistoryStack.push(eventData.referer);
            }
            if (eventData.service) {
                this.service = eventData.service;
            }
            this.selectedTab = eventData.dest;
        }
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(selectedTab) {
        this._selectedTab = selectedTab;
    }

    get responseStatus() {
        return this.opacService.responseStatus;
    }

    public getResponseMessage(){
        return this.opacService.getResponseMessage();
    }

    get displayErrorMessage() {
        return this.requestService.displayErrorMessage;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/purchaseRequest/purchaseRequest.directive.ts